import React, { useState, useEffect, useContext } from "react";
import { useParams, useHistory } from "react-router";
import { Button, TextField } from "@mui/material";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import Swal from "sweetalert2";
import Toast from "../../utils/Toast";

import { AuthContext } from "../../utils/userProvider";

import useCreditNote from "../../queries/creditNote/getCreditNote";
import useCreateAudit from "../../mutation/audit/createAudit";
import {
  FormPageShell,
  FormPageCard,
  FormPageHeader,
  FormActions,
} from "../../components/ListPage";

const schema = yup.object().shape({
  amount: yup.number().required("Amount is required"),
});

const EditCreditNote = (props) => {
  const { id } = useParams();
  const history = useHistory();
  const [response, resetCreditNote] = useCreditNote(id);
  const { authState, setAuthState } = useContext(AuthContext);

  const [auditResponse, setAuditData] = useCreateAudit();

  const [currentData, setCurrentData] = useState();
  const [snapshotCurrent, setSnapshotCurrent] = useState({});

  const { register, handleSubmit, setValue, errors } = useForm({
    resolver: yupResolver(schema),
  });

  useEffect(() => {
    console.log(errors);
  }, [errors]);

  useEffect(() => {
    if (response.data) {
      setSnapshotCurrent(response.data);
      setCurrentData(response.data.id);
      setValue("amount", response.data.amount);
    }
  }, [response]);

  const goBack = () => {
    window.location.href = "/dashboard/creditnote";
  };

  const onSubmit = (values) => {
    console.log(values);

    Swal.fire({
      title: "Create Updates",
      html: `<h4>Please provide a description before submitting your changes</h4>
              <textarea maxlength="100" type="text" id="actionDescription" class="swal2-input" placeholder="Description" font-size=18px style="height:auto!important" rows=5>`,
      confirmButtonText: "Confirm",
      focusConfirm: false,
      preConfirm: () => {
        const actionDescription =
          Swal.getPopup().querySelector("#actionDescription").value;
        if (!actionDescription) {
          Swal.showValidationMessage(`Please enter description`);
        }
        return {
          actionDescription: actionDescription,
          newData: values,
          snapshotCurrent: snapshotCurrent,
          currentData: currentData,
          type: "credit-notes",
          action: "update",
        };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        setAuditData(result.value);
      }
    });
  };

  useEffect(() => {
    try {
      if (auditResponse.data) {
        Toast.fire({
          icon: "success",
          title: "Credit Note update Audit Created",
        });
        history.push("/dashboard/creditnote");
      } else if (auditResponse.error) {
        let data = auditResponse.errorMessage.response.data;
        if (data) {
          let messageData = data.message;
          let message = messageData.message;
          Swal.fire({
            icon: "error",
            title: "Error",
            text: message,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: auditResponse.error.message,
          });
        }
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: err.message,
      });
    }
  }, [auditResponse]);

  const renderContent = () => {
    return (
      <FormPageShell>
        <form noValidate onSubmit={handleSubmit(onSubmit)}>
          <FormPageCard>
            <FormPageHeader
              title={
                authState.editAccess
                  ? "Edit Credit Note"
                  : "View Credit Note"
              }
              onBack={goBack}
              subtitle={
                authState.editAccess
                  ? "Please fill in the required fields."
                  : undefined
              }
            />
            <TextField
              name="amount"
              margin="normal"
              fullWidth
              label="Amount*"
              variant="outlined"
              inputRef={register}
              type="number"
              error={errors.amount != null}
              helperText={
                errors.amount != null ? errors.amount.message : null
              }
              disabled={auditResponse.loading || !authState.editAccess}
            />
          </FormPageCard>
          {authState.editAccess && (
            <FormPageCard sx={{ mt: 2 }}>
              <FormActions>
                <Button
                  type="submit"
                  size="large"
                  variant="contained"
                  color="primary"
                  disabled={auditResponse.loading}
                >
                  Submit
                </Button>
              </FormActions>
            </FormPageCard>
          )}
        </form>
      </FormPageShell>
    );
  };

  return !response.loading && renderContent();
};

export default EditCreditNote;
